export const LAYOUT_CHANGE_EVENT = 'kirinus-layout-change';
export function tryExecution(action)
{
    if (action == null || typeof action !== "function") {
        console.warn("Unable to execute action, function expected. Action: ", action);

        return;
    }

    try {
        return action();
    } catch (e) {
        console.error("An unexpected error occured during action execution", e);
    }
}
export function dispatchLayoutChange() {
    document.dispatchEvent(new CustomEvent(LAYOUT_CHANGE_EVENT));
}
export function isUrlEqual(relativeUrl, absoluteUrl) {
    const cleanRelativeUrl = relativeUrl?.trim();
    const cleanAbsoluteUrl = absoluteUrl?.trim();

    if (cleanRelativeUrl == null || cleanAbsoluteUrl == null || cleanRelativeUrl === '' || cleanAbsoluteUrl === '') {
        return false;
    }

    if (relativeUrl === absoluteUrl) {
        return true;
    }

    const currentUrl = new URL(absoluteUrl);
    const convertedRelativeUrl = new URL(relativeUrl, currentUrl.origin);

    return convertedRelativeUrl.href === currentUrl.href;
}




export default {

    tryExecution,

};